import { SyntheticEvent } from 'react'

import {
  FormControlLabel,
  Checkbox as MuiCheckbox,
  SxProps,
  Theme,
} from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

interface ICheckbox {
  name: string
  label?: string
  disabled?: boolean
  value?: string | boolean
  onChange?: (e: React.SyntheticEvent<Element, Event>, checked: boolean) => void
  labelPlacement?: 'start' | 'end' | 'top' | 'bottom'
  sx?: SxProps<Theme> | undefined
  required?: boolean
  defaultChecked?: boolean
}

const Checkbox = ({
  name,
  disabled = false,
  label,
  onChange,
  value,
  labelPlacement = 'end',
  sx,
  required,
  defaultChecked,
}: ICheckbox) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      disabled={disabled}
      render={({ field }) => {
        return (
          <FormControlLabel
            onChange={(
              event: SyntheticEvent<Element, Event>,
              checked: boolean
            ) => {
              field.onChange(checked)
              if (onChange) {
                onChange(event, checked)
              }
            }}
            control={<MuiCheckbox />}
            name={field.name}
            value={value}
            label={label}
            onBlur={field.onBlur}
            ref={field.ref}
            disabled={disabled}
            checked={field.value}
            labelPlacement={labelPlacement}
            sx={sx}
            required={required}
            defaultChecked={defaultChecked}
          />
        )
      }}
    />
  )
}

export default Checkbox
